import SessionContextProvider from "../security/context/SessionContext"; 
import { useUserSession } from "../security/hooks/useUserSession"; 
import PublicRoute from "./PublicRoute";
import SecurityRoute from "./SecurityRoute";
import PrivateRoute from "./PrivateRoute";
import { Route, Routes } from "react-router-dom";
import NotFoundRoute from "./NotFoundRoute";
// import PageContextProvider from "Context/PageContext";
import PageLoading from "../components/PageLoading";
import React from "react";

const AppContent = () => {
	const { session, setSession, isPageLoading, setIsPageLoading } = useUserSession();

	return (
		<SessionContextProvider value={{ session, setSession }}>
		{/* <SessionContextProvider> */}
							{isPageLoading ? <PageLoading /> : (
								<React.Fragment>
									<SecurityRoute />
									<PrivateRoute />
									<PublicRoute />
									<NotFoundRoute />
								</React.Fragment>
							)}
		</SessionContextProvider>
	);
};

export default AppContent;